/**
 * Сумма, набранная человеком в батах, — в сатанги (железное правило 4).
 *
 * Одна функция на весь бэк-офис: конструктор акций, баллы вручную. Два разных
 * разбора одной и той же «799,5» рано или поздно разойдутся на копейку.
 *
 * «800», «799,5», «799.99» → сатанги. Ноль, минус, больше двух знаков после
 * запятой и мусор — null: вызывающий показывает подсказку, а не отправляет.
 */
export const bahtToMinor = (value: string): number | null => {
  const trimmed = value.trim().replace(',', '.')

  if (!/^\d{1,7}(\.\d{1,2})?$/.test(trimmed)) {
    return null
  }

  const minor = Math.round(Number(trimmed) * 100)

  return minor > 0 ? minor : null
}
